<script setup lang="ts">
  import {
    onMounted,
    ref,
    useTemplateRef,
    watch
  } from 'vue';

  const emit = defineEmits(['selectionChanged']);

  interface Props {
    activitySelected: string;
  };

  const {
    activitySelected = '',
  } = defineProps<Props>();

  const picked = ref<string>('SingleRetirement');
  const activityElementsByName = ref<Map<string, Element>>();
  const activitiesContainer = useTemplateRef<HTMLDivElement>('activitiesContainer');

  function getActivityElements(): Map<string, Element> {
    const thisElement = activitiesContainer.value;

    const elems = new Map<string, Element>();

    if (thisElement) {
      Array.from(thisElement.children)
           .filter(e => e.hasAttribute('activityName'))
           .forEach(e => {
             const name = e.getAttribute('activityName')!;
             elems.set(name, e);
           });
    }

    return elems;
  }

  function setActivityVisibility(): void {
    if (!activityElementsByName.value) {
      return;
    }

    activityElementsByName.value.forEach((elem, name) => {
      const selected = name == picked.value;
      if (selected) {
        elem.setAttribute('activitySelected', 'true');
      } else {
        elem.removeAttribute('activitySelected');
      }
    });

    emit('selectionChanged', picked.value);
  }

  watch(activitiesContainer, (_old, _new) => {
    activityElementsByName.value = getActivityElements();
    setActivityVisibility();
  });

  watch(picked, (_old, _new) => {
    setActivityVisibility();
  });

  onMounted(()=>{
    activityElementsByName.value = getActivityElements();
    console.log(`ActivitySelector selected ${activitySelected}`);
    picked.value = activitySelected;
  });
</script>

<template>
  <h1>What are we doing?</h1>

  <div class="input-card">
    <table>
      <template v-for="name in activityElementsByName?.keys()">
        <tr>
          <td>
            <input type="radio" :value="name" v-model="picked" />
            <label for="name">{{name}}</label>
          </td>
        </tr>
      </template>
    </table>
  </div>

  <div ref="activitiesContainer">
    <slot>
      <div class="slot-warning">expected slot content here</div>
    </slot>
  </div>
</template>

<style scoped>
  .input-card {
    border-color: skyblue;
  }

  .slot-warning {
    color: red;
  }
</style>
